export default "__VITE_ASSET__CFcNxiar__"